import { GiotanksGraph } from "../views/GiotanksGraph/GiotanksGraph";

import DashboardIcon from "@material-ui/icons/Dashboard";

export const giotanksRoutes = [
  {
    path: "/grafica_giotank/:id/:serie",
    name: "Detalle giotank",
    icon: DashboardIcon,
    component: GiotanksGraph,
    layout: "/admin",
    sublayout: "/grafica_giotank",
    inSidebar: false,
  },
]